import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';

function ValidationValidColourMedium(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("g", {
    fill: "#070"
  }, React.createElement("path", {
    stroke: "#070",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M11.993 23.055c6.11 0 11.062-4.953 11.062-11.063S18.102.93 11.993.93C5.883.93.93 5.883.93 11.992c0 6.11 4.953 11.063 11.063 11.063z",
    opacity: 0.1
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.546 7.721a.75.75 0 01-.032 1.06l-7.91 7.436a.75.75 0 01-1.027 0l-4.09-3.846a.75.75 0 011.027-1.093l3.577 3.363 7.395-6.953a.75.75 0 011.06.033z",
    clipRule: "evenodd"
  })));
}

export default ValidationValidColourMedium;
//# sourceMappingURL=ValidationValidColourMedium.js.map